import { useEffect } from "react";
import { useLocation } from "react-router";

export function useUnload(callback) {
    const location = useLocation();
    useEffect(() => {
        return () => {
            callback();
        };
    }, [location]);
    useEffect(() => {
        const handler = event => {
            callback();
            // event.preventDefault();
            // event.returnValue = "";
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [callback]);
}